import { render } from "./AdminLayout.vue?vue&type=template&id=31c29fdf&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=31c29fdf&scoped=true&lang=css"

import exportComponent from "/Users/mathias/Developer/vue-firebase-stundenzettel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c29fdf"]])

export default __exports__